import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const PaymentDetailsPage = lazy(() => import('./PaymentDetailsPage'));
const PaymentDetailsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Payments,
  routes: [
    {
      path: 'payments/:paymentId',
      element: <PaymentDetailsPage />,
    },
  ],
};

export default PaymentDetailsConfig;
